import React from 'react';

export default function getChildrenWithoutComponent({ children, component }) {
  return React.Children.map(children, function(child) {
    if (child && component === child.type)
      return null;

    return child;
  });
}
